// src/theme.js

const theme = {
    colors: {
      primary: '#ec1a23', // Red color for primary
      secondary: '#00a2e7', // Blue color for secondary
      background: '#ffffff', // White background color
      textPrimary: '#333333', // Primary text color
      textSecondary: '#555555', // Secondary text color
    }
    }
  
  export default theme;
  